import { Component, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'libero-consult-image',
  templateUrl: './consult-image.component.html',
  styleUrl: './consult-image.component.scss',
  standalone: false,
})
export class ConsultImageComponent {
  @Input({ required: true }) public imageSrc: string | SafeUrl | null = null;
}
